export default __webpack_public_path__ + "static/media/SPEKTRA.2aeac43e.png";